import { render, staticRenderFns } from "./BaseContainer.vue?vue&type=template&id=be3d94bc&scoped=true&"
import script from "./BaseContainer.vue?vue&type=script&lang=js&"
export * from "./BaseContainer.vue?vue&type=script&lang=js&"
import style0 from "./BaseContainer.vue?vue&type=style&index=0&id=be3d94bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be3d94bc",
  null
  
)

export default component.exports